import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import '../FirstPageDesigns/FirstPage.css';
import searchinterfacesymbol from '../../../Assets/search-interface-symbol.png'
import assignedTask from '../../../Assets/assignedTask.png'
import comingCrane from '../../../Assets/comingCrane.png'
import checksuccess from '../../../Assets/checksuccess.png'
import crossUser from '../../../Assets/crossUser.png'
import historyUser from '../../../Assets/historyUser.png'
import workDoneUser from '../../../Assets/workDoneUser.png'
import reachedUser from '../../../Assets/reachedUser.png'
import filterUser from '../../../Assets/filterUser.png'
import Modal from '../../../Component/CompanyAdmin/Location1/Modal.jsx';
import NoDataFound from '../../../Component/Customers/Cards/NoDataFound.jsx';
import Loading from '../../../Component/Customers/Cards/Loading.jsx';
import icon11 from '../../../Assets/crane/icon11.svg'
import icon12 from '../../../Assets/crane/icon12.svg'
import icon13 from '../../../Assets/crane/icon13.svg'
import img2 from '../../../Assets/claimpro-design-home/image2.png'
import icon14 from '../../../Assets/crane/icon14.svg'
import icon15 from '../../../Assets/crane/icon15.svg'
import icon16 from '../../../Assets/crane/icon16.svg'
import search from '../../../Assets/home2/search.svg'
import mediumCrane from '../../../Assets/crane/mediumCrane.jpg'
import mediumRecoveryVan from '../../../Assets/crane/mediumRecoveryVan.jpg'

import CraneSideBar from '../../../Component/Customers/slidebar/CraneSideBar.jsx'
import { Download, Upload } from 'lucide-react';
import TDSApplicationPage from '../../CompanyAdmin/VendorsDetails/VenderMaster/TDSApplicationPage.jsx';
import { Close } from '@mui/icons-material';
import DownloadInvoiceButton from './DownloadInvoiceButton.jsx';


const btns = [
    { name: "Complete Process", id: 1 },
    { name: "Process", id: 2 },
]

const HistoryDetails = ({ currentService }) => {
    const navigate = useNavigate()
    const { state } = useLocation();
    // const currentService = localStorage.getItem("currentService");
    // console.log('currentserive', currentService)
    const [currentServiceImage, setCurrentServiceImage] = useState(null);
    useEffect(() => {
        if (currentService == 'crane') setCurrentServiceImage(mediumCrane)
        if (currentService == 'recoveryVan') setCurrentServiceImage(mediumRecoveryVan)
    }, [currentService])


    const [currentStage, setCurrentStage] = useState([]); // Example stage
    //console.log("currentStage112", currentStage)
    const [isHistoryPage, setIsHistoryPage] = useState(false);
    const [viewReceipts, setViewReceipts] = useState(false);
    const [showTDSModal, setShowTDSModal] = useState(false);
    const [accidentVehicleCode, setAccidentVehicleCode] = useState(null);

    const [avg, setAvg] = useState([])
    const [data, setData] = useState([]);
    const [filtering, setFiltering] = useState([]);
    const [notCompleted, setNotCompleted] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [doneFetching, setDoneFetching] = useState(false)

    const [filter, setFilter] = useState('')

    //console.log("DATA HERE", data)
    const [currentItemIndex, setCurrentItemIndex] = useState(null);
    const [dataIndex, setDataIndex] = useState(0);

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    //console.log('isImageContainer', isHistoryPage)

    const getFilteredData = (filter) => {
        //console.log("data is here");
        const filteredData = [];

        const now = new Date();  // Current date and time
        const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
        const yesterday = new Date(now.getTime() - oneDay); // Yesterday's date and time
        const weekBefore = new Date(now.getTime() - (oneDay * 7));
        const monthBefore = new Date(now.getTime() - (oneDay * 30));




        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const todayDate = formatDate(now);
        const yesterdayDate = formatDate(yesterday);
        const weekBeforeDate = formatDate(weekBefore)
        const monthBeforeDate = formatDate(monthBefore)

        //console.log("todayDate", todayDate)
        //console.log("yesterdayDate", yesterdayDate)


        for (let i = 0; i < filtering.length; i++) {

            let getTime = filtering[i]?.[`${currentService}Details`]?.systemDate.split('|');
            let assignedDate = getTime[0];
            let assignedTime = getTime[1];
            let assignedDateTime = new Date(`${assignedDate} ${assignedTime}`);

            if (filter === 'daily') {
                //console.log("here i am daily")
                if (assignedDate === todayDate || assignedDate === yesterdayDate) {
                    const timeDifference = now - assignedDateTime;
                    if (timeDifference <= oneDay) {
                        //console.log("Match found within last 24 hours:", data[i]);
                        filteredData.push(filtering[i]);
                    }
                }
            }
            else if (filter === 'weekly') {
                //console.log("here i am weekly")
                if (assignedDateTime >= weekBefore && assignedDateTime <= now) {
                    //console.log("Match found within last 7 days:", data[i]);
                    filteredData.push(filtering[i]);
                }
            }
            else if (filter === 'monthly') {
                if (assignedDateTime >= monthBefore && assignedDateTime <= now) {
                    //console.log("Match found within last 30 days:", data[i]);
                    filteredData.push(filtering[i]);
                }
            }
            else if (filter === 'year') {
                const yearBefore = new Date(now.getTime() - (oneDay * 365)); // Calculate date one year ago
                if (assignedDateTime >= yearBefore && assignedDateTime <= now) {
                    //console.log("Match found within last year:", filtering[i]);
                    filteredData.push(filtering[i]);
                }
            }

        }
        if (filter === 'newest') {
            //console.log("Sorting by newest to oldest");
            //console.log("filtering", filtering[0])
            filtering.sort((a, b) => {
                //console.log("a?.[`${currentService}Details`]?.systemDate", a?.[`${currentService}Details`]?.systemDate)
                const dateA = new Date(a?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                const dateB = new Date(b?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                return dateB - dateA; // Descending order
            });
            setData([...filtering]);
        } else if (filter === 'oldest') {
            //console.log("Sorting by oldest to newest");
            filtering.sort((a, b) => {
                const dateA = new Date(a?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                const dateB = new Date(b?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                return dateA - dateB; // Ascending order
            });
            setData([...filtering]);
        }
        else {
            setData(filteredData)
        }
    };

    const settingFilter = (filter) => {
        //console.log("filter", filter)
        setFilter(filter)
        getFilteredData(filter)
        setOpenFilterModal(false)
    }



    const goToMap = () => {
        navigate('/SelectLocationOnMap', { state: { center: [28.7041, 77.1025] } })
    }

    useEffect(() => {
        //console.log('hey123323')
        setDoneFetching(false)
        getData();
        // getVendorRating()
        //console.log("token", token, userId);
        if (token === "" || userId === "") {
            navigate("/");
        }
    }, [token, userId, navigate, currentService]);


    useEffect(() => {
        if (data.length > 0 && data.length != currentStage.length) {
            data.map((item) => {
                avg.push(0)
            })

        }

    }, [data])

    const getStage = (systemDate, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime) => {
        return [systemDate, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime]
    }
    const getStageAndHistory = (item, index) => {

        let gotStage = getStage(item?.[`${currentService}Details`]?.systemDate, item?.[`${currentService}Details`]?.customerAcceptedVendorTime, item?.[`${currentService}Details`]?.vendorMovedTime, item?.[`${currentService}Details`]?.vendorReachedTime, item?.[`${currentService}Details`]?.doneWorkingTime)
        console.log('goto stage: ==================');
        console.log(gotStage);
        currentStage.unshift(gotStage)

        console.log('currentStage ');
        console.log(currentStage);
    }

    const [stages, setStages] = useState([]); // Use useState for stages
    //console.log("stages123456789 ================================= ", stages)

    useEffect(() => {
        //console.log("hello currentStage", currentStage);
        if (currentStage[0]) {
            //console.log("helasdfasdflo");
            //console.log("currentStage[0][0] ", currentStage[0])
            setStages([
                { label: "Filed", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/assignedTask.png', date: currentStage[0][0] ? currentStage[0][0].split('T')[0] + ' | ' + currentStage[0][0].split('T')[1].split('.')[0] : '' },
                { label: "Vendor Assigned", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/checksuccess.png', date: currentStage[0][1] ? currentStage[0][1].split('T')[0] + ' | ' + currentStage[0][1].split('T')[1].split('.')[0] : "" },
                { label: "Accepted & Moved", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/comingCrane.png', date: currentStage[0][2] ? currentStage[0][2].split('T')[0] + ' | ' + currentStage[0][2].split('T')[1].split('.')[0] : "" },
                { label: "Reached", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/reachedUser.png', date: currentStage[0][3] ? currentStage[0][3].split('T')[0] + ' | ' + currentStage[0][3].split('T')[1].split('.')[0] : "" },
                { label: "Work Done", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/workDoneUser.png', date: currentStage[0][4] ? currentStage[0][4].split('T')[0] + ' | ' + currentStage[0][4].split('T')[1].split('.')[0] : "" },
            ]);
        }
    }, [currentStage[0]]); // Dependency array

    // useEffect(() => {
    //     //console.log("stages updated:", stages);
    // }, [stages]);

    const getData = async (e) => {
        //console.log("userid", userId);
        // const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getPersonalAccidentVehicleInfoById/${userId}/${currentService}/not_defined`, {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // });

        // const response = await axios.get(`http://localhost:3001/api/getPersonalAccidentVehicleInfoById/CC-ea5ff8d5-9058-476a-8df1-97ddc452f010/recoveryVan/not_defined`, {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getPersonalAccidentVehicleInfoById/${userId}/${currentService}/not_defined`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (response.data.message === "No accident vehicle data found.") {
            setData([])
            //console.log('hellow not data')
            setDoneFetching(true)
        }
        else {
            console.log("response123421", response.data.data);
            //console.log("data2", response.data.data2);

let filteredData = response.data.data
  .filter((info) =>
    info?.[`${currentService}Details`]?.confirmDoneWorkingTime &&
    info?.[`${currentService}Details`]?.confirmDoneWorking === 1 &&
    info?.[`${currentService}Details`]?.customerAcceptedVendor === 1 &&
    info?.[`${currentService}Details`]?.cancelOrder === 0 &&
    info?.[`${currentService}Details`]?.cancelPreAssignOrder === 0 &&
    info?.[`${currentService}Details`]?.completeOrder === 1
  )
  .sort((a, b) =>
    new Date(b?.[`${currentService}Details`]?.confirmDoneWorkingTime) -
    new Date(a?.[`${currentService}Details`]?.confirmDoneWorkingTime)
  );

            let notCompleted = response.data.data.filter((info) =>
                info?.[`${currentService}Details`]?.confirmDoneWorking === 0 &&
                info?.[`${currentService}Details`]?.cancelOrder === 0 &&
                info?.[`${currentService}Details`]?.cancelPreAssignOrder === 0 &&
                info?.[`${currentService}Details`]?.completeOrder === 0
            );

            //console.log('fileteredData', filteredData);
            //console.log('notCompleted', notCompleted);

            // Add vehicle image to each item
            const enhancedFilteredData = filteredData.map(item => ({
                ...item,
                vehicleImage: item?.[`${currentService}Details`]?.images?.['Front Right'] || 
                            item?.[`${currentService}Details`]?.images?.['Front Left'] || 
                            item?.[`${currentService}Details`]?.images?.['Rear Right'] || 
                            item?.[`${currentService}Details`]?.images?.['Rear Left']
            }));

            setFiltering(enhancedFilteredData)
            setFilteredData(enhancedFilteredData);
            setData(enhancedFilteredData)
            setNotCompleted(notCompleted)
            //console.log('hellow data2')
            setDoneFetching(true)
            console.log("item?.[`${currentService}Details`]?.systemCreatedInvoice", currentService, filteredData[0]?.[`${currentService}Details`]);

            console.log("item?.[`${currentService}Details`]?.systemCreatedInvoice", filteredData[0]?.[`${currentService}Details`].systemCreatedInvoice);

            console.log("filteredData", filteredData);

            console.log(stages);
        }
    };

    // const getVendorRating = async (crane) => {
    //     try {
    //         const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/customersRating/${crane}`);
    //         //console.log("coming Customer Rating", response.data)
    //         if (response.data.status === 404) {
    //             //console.log("Not Found")
    //             avg.push(0)
    //         }
    //         else if (response.data.status === true) {
    //             let customerRating = response.data.data;
    //             //console.log("coming Customer Rating", customerRating)
    //             if (customerRating.length !== 0) {
    //                 let average = customerRating.reduce((acc, item) => acc + parseInt(item.feedbackRatingCrane), 0);

    //                 avg.push(average / customerRating.length);
    //             }
    //         }
    //     } catch (error) {
    //         //console.log("Error from get Vendor Rating", error.message)
    //     }
    // }

    const [searchValue, setSearchValue] = useState('');


    useEffect(() => {
        return () => setSearchValue('');
    }, []);
    const handleSearch = (inputValue) => {
        const value = inputValue?.toLowerCase() ?? searchValue.toLowerCase()
        setSearchValue(value);
        //console.log("VALUE123", value)

        const newRows = filtering.filter((row) => {
            const formattedId = String(row.id).padStart(4, '0').toLowerCase();
            const idValue = formattedId.includes(value);
            const vehicleNoValue = (row?.[`${currentService}Details`]?.vehicleNo ?? '').toLowerCase().includes(value);
            const chassisNoValue = (row?.[`${currentService}Details`]?.chassisNo ?? '').toLowerCase().includes(value);
            return idValue || vehicleNoValue || chassisNoValue;
        });
        setData(newRows);
    };

    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleSelect = (index) => {

        setSelectedIndex(index);
        //console.log("SELECTEDINDOEX", index)
        //console.log("filtering", filtering)

        if (index === 0) {
            setFiltering([...filteredData]);
            setData([...filteredData]);
        } else {
            setData([...notCompleted]);
        }
        console.log('filtering', filteredData)
        //console.log("d", notCompleted.length)
        //console.log("notCompleted", data.length)
    };

    const [hBtn, setHBtn] = useState("Complete Process")

    const callButtonClick = (e) => {

        console.log(e);
        setHBtn(e)
        let index = e === 'Complete Process' ? 0 : 1;
        console.log(index);
        handleSelect(index)

    }

    const openTDSModal = (accidentVehicleCode) => {
        setShowTDSModal(true);
        setAccidentVehicleCode(accidentVehicleCode)
    }



    return (

        <>

            {/* <div className=' flex md:flex-row flex-col justify-center gap-[30px]'> */}
            {/* <CraneSideBar /> */}
            {/* <div className=' w-full border-[1px] border-[#E7E4FC] rounded-[12px]'> */}

            {/* <div className='tab-content'>
                <div className='bookboxs'>
                    <div className="bookbox">
                        <div className="bookbox-img">
                            <img src={img2} />
                        </div>
                        <div className="bookbox-text">
                            <div className="bookbox-steper">
                                <div className="bookbox-steper-div-section">
                                    <div className="bookbox-steper-div">
                                        <i class="bi bi-card-heading"></i>
                                    </div>
                                    <p>Filled</p>
                                </div>
                                <div className="bookbox-steper-div-section">
                                    <div className="bookbox-steper-div">
                                        <i class="bi bi-patch-check-fill"></i>
                                    </div>
                                    <p>Vender<br />Assigned</p>
                                </div>
                                <div className="bookbox-steper-div-section">
                                    <div className="bookbox-steper-div">
                                        <i class="bi bi-list-check"></i>
                                    </div>
                                    <p>Accepted</p>

                                </div>
                                <div className="bookbox-steper-div-section">
                                    <div className="bookbox-steper-div">
                                        <i class="bi bi-megaphone-fill"></i>
                                    </div>
                                    <p>Reacted</p>
                                </div>
                                <div className="bookbox-steper-div-section">
                                    <div className="bookbox-steper-div">
                                        <i class="bi bi-hand-thumbs-up-fill"></i>
                                    </div>
                                    <p>Work <br />Done</p>
                                </div>


                            </div>
                            <div className="font-semibold my-2 mb-3"> HR83TS9232</div>
                            <div className="text-[15px] font-semibold opacity-60 my-2"> Recovery Van Service</div>

                            <div className="bookbox-text-hover-content">

                                <button >Dowload Invoice</button>
                                <button>Upload TDS</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div> */}


            {data.length > 0 ? (
                <div className="tab-content">
                    <div className="bookboxs">
                        {data.map((item, dataIndex) => (
                            <div key={dataIndex} className="bookbox">
                                <div className="bookbox-img">
                                    <img 
                                        src={item.vehicleImage || currentServiceImage} 
                                        className='object-contain' 
                                        alt="service" 
                                    />
                                </div>

                                <div className="bookbox-text">
                                    <div className="bookbox-steper">
                                        <div className="bookbox-steper-div-section">
                                            <div className="bookbox-steper-div">
                                                <i className="bi bi-card-heading"></i>
                                            </div>
                                            <p>Filled</p>
                                        </div>
                                        <div className="bookbox-steper-div-section">
                                            <div className="bookbox-steper-div">
                                                <i className="bi bi-patch-check-fill"></i>
                                            </div>
                                            <p>Vendor<br />Assigned</p>
                                        </div>
                                        <div className="bookbox-steper-div-section">
                                            <div className="bookbox-steper-div">
                                                <i className="bi bi-list-check"></i>
                                            </div>
                                            <p>Accepted</p>
                                        </div>
                                        <div className="bookbox-steper-div-section">
                                            <div className="bookbox-steper-div">
                                                <i className="bi bi-megaphone-fill"></i>
                                            </div>
                                            <p>Reached</p>
                                        </div>
                                        <div className="bookbox-steper-div-section">
                                            <div className="bookbox-steper-div">
                                                <i className="bi bi-hand-thumbs-up-fill"></i>
                                            </div>
                                            <p>Work<br />Done</p>
                                        </div>
                                    </div>

                                    <div className="bookbox-text-hover-content mt-4">

                                        <div className="font-semibold mb-1 ">
                                            {item?.[`${currentService}Details`]?.vehicleNo}
                                        </div>

                                        <div className="text-[15px] font-semibold opacity-60">
                                            {currentService
                                                .replace(/([A-Z])/g, ' $1')
                                                .replace(/^./, (str) => str.toUpperCase())}{' '}
                                            Service
                                        </div>
                                    </div>

                                    <div className="bookbox-text-hover-content">

                                        <button
                                            onClick={() => {
                                                const link = document.createElement('a');
                                                link.href = item?.[`${currentService}Details`]?.systemCreatedInvoice;
                                                link.download = '';
                                                link.target = '_blank';
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                            }}
                                        >
                                            Download Invoice
                                        </button>

                                        <button
                                            onClick={() =>
                                                openTDSModal(item?.[`${currentService}Details`]?.AccidentVehicleCode)
                                            }
                                        >
                                            Upload TDS
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* TDS Modal */}
                    {showTDSModal && (
                        <div className="fixed inset-0 bg-[#38323287] bg-opacity-40 flex items-center justify-center z-50 shadow-lg rounded-xl">
                            <div className="relative w-[95vw] max-w-3xl bg-white rounded-xl p-4 shadow-lg overflow-auto max-h-[90vh]">
                                <button
                                    onClick={() => setShowTDSModal(false)}
                                    className="absolute top-2 right-2 text-gray-500 hover:text-red-500"
                                >
                                    <Close />
                                </button>
                                <TDSApplicationPage
                                    state={{ accidentVehicleCode: accidentVehicleCode }}
                                    closeModal={() => setShowTDSModal(false)}
                                />
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div className="text-center text-gray-400 py-10">No Details Found</div>
            )}
        </>
    )
}

export default HistoryDetails;



{/* {hBtn === "Process" &&
                                    <div className="grid md:grid-cols-2 grid-cols-1 gap-[23px]">

                                        {data.map((item, dataIndex) => (

                                            <div className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] py-[40px] px-[30px] rounded-[12px] ">

                                                <ol className="flex items-start gap-[3px] justify-between his-line max-w-[536px] pl-0 mb-0 mx-auto w-full">
                                                    <li className='h-full w-[38px]' title={item?.[`${currentService}Details`]?.systemDate?.replace('T', ' | ').replace('.000Z', '')} >
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src={icon12} className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[11px] sm:text-[13px] text-[#21A6E9] text-center">Filled</p>
                                                        </div>
                                                    </li>
                                                    <li className='w-[60px]' title={item?.[`${currentService}Details`]?.customerAcceptedVendorTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src={icon13} className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[11px] sm:text-[13px] text-[#21A6E9] text-center">Vendor Assigned</p>
                                                        </div>
                                                    </li>
                                                    <li className='w-[60px]' title={item?.[`${currentService}Details`]?.vendorMovedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src={icon14} className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[11px] sm:text-[13px] text-[#21A6E9] text-center">Accepted & Moved</p>
                                                        </div>
                                                    </li>
                                                    <li className='w-[60px]' title={item?.[`${currentService}Details`]?.vendorReachedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src={icon15} className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[11px] sm:text-[13px] text-[#21A6E9] text-center">Reached</p>
                                                        </div>
                                                    </li>
                                                    <li className='w-[60px]' title={item?.[`${currentService}Details`]?.doneWorkingTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src={icon16} className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[11px] sm:text-[13px] text-[#21A6E9] text-center">Work Done</p>
                                                        </div>
                                                    </li>
                                                </ol>

                                                <div className="flex justify-center">
                                                    <img src={icon11} className='h-[150px] w-[150px] py-[28px]' alt="" />
                                                </div>

                                                <div className="grid sm:grid-cols-2 gap-[60px] gap-y-[20px]">
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.[`${currentService}Details`]?.vehicleNo}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vehicle No</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.[`${currentService}Details`]?.systemDate?.split("T")[0]}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Registered Date</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">Crane Work</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vendor</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">Processing</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Current Status</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                    </div> */}
